import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { useHistory, useParams } from 'react-router-dom';
import CtiSetting from 'flow/components/Setting/CtiSettings/CtiSetting';
import CtiSettingList from 'flow/components/Setting/CtiSettings/CtiSettingList';
import { getIntegrationHost } from 'flow/utils/is-integration';
import { getCtiSetting, CTI_SETTINGS_KEY } from 'flow/utils/cti-settings-utils';
import useAppContext from 'flow/hooks/useAppContext';
import {
    CTIListSettingKey,
    CTISingleSettingKey,
    CTISettingsKey,
} from 'flow/types/CTISettings';
import Page from 'flow/components/Setting/Page';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import useSinglePaneMode from 'flow/hooks/useSinglePaneMode';
import { generatePath } from 'flow/utils/router-utils';

const CtiSettings = () => {
    const { i18next } = useAppContext();
    const history = useHistory();
    const { extensionKey } = useParams<{
        extensionKey: ExtensionKey;
    }>();

    const ctiSetting = useAppSelector(getCtiSetting);
    const { isSinglePaneMode } = useSinglePaneMode();

    const integrationHost = getIntegrationHost() || '';

    return (
        <Page
            header={`${integrationHost} ${i18next.t('settings')}`}
            onClickBack={
                isSinglePaneMode
                    ? () =>
                          history.push(
                              generatePath(routes['settings'], {
                                  extensionKey,
                              }),
                          )
                    : undefined
            }
        >
            {Object.keys(ctiSetting).map((propertyName: CTISettingsKey) => {
                return (
                    <>
                        {[
                            CTI_SETTINGS_KEY.logCallsAutomatically,
                            CTI_SETTINGS_KEY.hideOnAction,
                        ].includes(ctiSetting[propertyName].key) ? (
                            <CtiSetting
                                extensionKey={extensionKey}
                                setting={ctiSetting}
                                propertyName={
                                    propertyName as CTISingleSettingKey
                                }
                            />
                        ) : [
                              CTI_SETTINGS_KEY.openOnCall,
                              CTI_SETTINGS_KEY.showOnLoad,
                              CTI_SETTINGS_KEY.openOnAnswer,
                          ].includes(ctiSetting[propertyName].key) ? (
                            <CtiSettingList
                                setting={ctiSetting}
                                propertyName={propertyName as CTIListSettingKey}
                            />
                        ) : null}
                    </>
                );
            })}
        </Page>
    );
};

export default CtiSettings;
